const ElementType = require('../enums/element-type');
const ValueType = require('../enums/value-type');

/**
* Element
*/

class Element {

    constructor(document, isCopy = false) {

        if (document === undefined) {
            this.uid = this.randomId()
            this.parentUID = ''
            this.title = ''
            this.type = ElementType.ATTRIBUTE
            this.description = ''
            this.isActive = false
            this.isMandatory = false
            this.elements = []
            this.values = []
            this.order = 0;
            this.valueType = ValueType.WRITTEN
        }
        else {
            const data = document.id ? document.data() : document
            this.uid = document.id ? document.id : (isCopy ? this.randomId() : document.uid)
            this.parentUID = data.parentUID ? data.parentUID : '';
            this.title = data.title ? data.title : '';
            this.type = data.type ? data.type : ElementType.ATTRIBUTE;
            this.description = data.description ? data.description : '';
            this.isActive = data.isActive ? data.isActive : false;
            this.isMandatory = data.isMandatory ? data.isMandatory : false;
            this.elements = data.elements ? data.elements.map(e => new Element(e, isCopy)) : [];
            this.elements.forEach(element => {
                element.parentUID = this.uid
                element.parentObject = this
            });
            this.values = data.values ? data.values : [];
            this.order = data.order ? data.order : 0;
            this.valueType = data.valueType ? data.valueType : ValueType.WRITTEN;
        }

    }

    randomId(length = 10) {
        var result = "";
        var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }


    get data() {
        return {
            uid: this.uid,
            parentUID: this.parentUID,
            title: this.title,
            type: this.type,
            description: this.description,
            isMandatory: this.isMandatory,
            isActive: this.isActive,
            elements: this.elements.map(e => e.data),
            values: this.values,
            order: this.order,
            valueType: this.valueType
        }
    }
}


export default Element;